import React from 'react';
import Svg from '../Svg';

const IconCloudSun01 = ({ ...props }) => (
  <Svg {...props} viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M11.0723 7.06571C11.521 4.19574 14.0041 2 17 2C20.3137 2 23 4.68629 23 8C23 9.71848 22.2773 11.2673 21.1214 12.3604C22.2728 13.3685 23 14.8493 23 16.5C23 19.5376 20.5376 22 17.5 22H7C3.68629 22 1 19.3137 1 16C1 12.8515 3.42516 10.2694 6.50941 10.0198C7.50426 8.45337 9.15253 7.3401 11.0723 7.06571ZM13.1032 7.09322C15.332 7.47421 17.1724 8.98978 18.0112 11.0234C18.4487 11.0638 18.8713 11.1553 19.273 11.292C20.318 10.5691 21 9.3636 21 8C21 5.79086 19.2091 4 17 4C15.1027 4 13.514 5.32089 13.1032 7.09322ZM12 9C10.2524 9 8.73567 9.996 7.98971 11.456C7.81561 11.7967 7.46233 12.0082 7.07975 12.0008C7.05322 12.0003 7.02664 12 7 12C4.79086 12 3 13.7909 3 16C3 18.2091 4.79086 20 7 20H17.5C19.433 20 21 18.433 21 16.5C21 14.567 19.433 13 17.5 13C17.4461 13 17.3925 13.0012 17.3392 13.0036C16.8752 13.0245 16.4578 12.723 16.3318 12.2759C15.7987 10.3847 14.0598 9 12 9Z"
    />
  </Svg>
);

export default IconCloudSun01;
